<client-header
  [headerLabel]="'Verification'"
  [headerGroup]="'verification'"
  (click)="headerGroups.verification = !headerGroups.verification"
  >
</client-header>

@if (headerGroups.verification && client.validation.fields) {
  <div
    class="collapse-container"
    >
    @if (client.feed_enabled) {
      <div class="verification-container">
        <rn-generic-phone [size]="'large'">
          <rn-verification-preview
            [pswEnabled]="productGroup.password.enabled"
            [pswTCS]="productGroup.password.tcs"
            [showPswTCS]="productGroup.password.tc_enabled"
            [showTCS]="productGroup.password.consent_upgrade_enabled"
            [pswTCMandatory]="productGroup.password.tc_mandatory"
            [fields]="verificationFieldsArray.value"
            [logoUrl]="productGroup.branding.icon_s3_url"
            [color]="productGroup.branding.color"
            [productGroupName]="productGroup.name"
            [showProductGroup]="!productGroup.hide_pg_wire_display_name"
            [productGroupDescription]="productGroup.description"
            [showFdic]="productGroup.fdic.show_signage_on_authentication"
            [fdic]="productGroup.fdic"
            [showBanner]="productGroup.show_banner"
            [bannerUrl]="productGroup.branding.banner_s3_url"
            [bannerAltText]="productGroup.branding.banner_alt_text"
            [showLogo]="productGroup.show_logo"
            [showTitleBar]="productGroup.show_title_bar"
            [consentTSCS]="productGroup.consent.in_wire_upgrade.ts_cs"
      [verificationBody]="
        verificationConfigForm.controls['body'].value
      "
      [verificationHeader]="
        verificationConfigForm.controls['header'].value
      "
      [verificationButtonLabel]="
        verificationConfigForm.controls['button_label'].value
      "
          ></rn-verification-preview>
        </rn-generic-phone>
        <div class="messaging-panel">
          <div class="card panel-default">
            <div class="card-header">
              <div class="col-sm-12">
                Verification Page Content
              </div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <rn-text-input
                  [inputLabel]="'Heading'"
                  [inputControl]="verificationConfigForm.controls['header']"
                  [placeholderText]="'Account Confirmation'"
                  [isFullWidth]="true"
                  >
                </rn-text-input>
              </div>
              <div class="form-group">
                <label class="input-label">Verification Fields</label>
                @for (fieldGroup of verificationFieldsArray.controls; track fieldGroup; let i = $index) {
                  <div
                    class="validation-fields-container"
                    [formGroup]="verificationFieldsArray.controls[i]"
                    >
                    <span class="validation-field-label">
                      {{fieldGroup.controls['field'].value}}
                      @if (fieldGroup.controls['field'].value === 'postal_code') {
                        <span
                          matTooltip="Verification by postal code will only verify the first 5 digits if the customer has a 9 digit postal zip on file."
                          style="margin-left: 0.5rem;"
                          >
                          <i class="fa fa-question-circle icon-color" aria-hidden="true"></i>
                        </span>
                      }
                    </span>
                    <span class="validation-field-input">
                      <rn-form-input-state-control
                        [formReference]="fieldGroup.controls['prompt']"
                        >
                        <input type="text" class="form-control" [formControl]="fieldGroup.controls['prompt']" />
                      </rn-form-input-state-control>
                    </span>
                  </div>
                }
              </div>
              <div class="form-group">
                <label class="input-label">Verification Page Message</label>
                <rn-form-input-state-control
                  [formReference]="verificationConfigForm.controls['body']"
                  [totalLength]="getCharacterLimit('verificationBody')"
                  [showCharacterCount]="true"
                  >
                  <app-tiny-editor
                    class="tiny-editor-mentions"
                    [elementId]="'tiny-editor-verification-message'"
                    [formControl]="verificationConfigForm.controls['body']"
                    style="width: 100%;"
                    [config]="tinyEditorConfig"
                    >
                  </app-tiny-editor>
                </rn-form-input-state-control>
              </div>
              <div class="form-group">
                <label>Submit Button Label</label>
                <rn-form-input-state-control
                  [formReference]="verificationConfigForm.controls['button_label']"
                  [totalLength]="getCharacterLimit('verificationButtonLabel')"
                  [showCharacterCount]="true"
                  >
                  <input
                    type="text"
                    class="form-control"
                    [formControl]="verificationConfigForm.controls['button_label']"
                    placeholder="Submit"
                    />
                </rn-form-input-state-control>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!client.feed_enabled) {
      <div class="label-tip">
        <label>Verification Fields</label>
      </div>
      @for (fieldGroup of verificationFieldsArray.controls; track fieldGroup; let i = $index) {
        <div
          class="validation-fields"
          [formGroup]="verificationFieldsArray.controls[i]"
          >
          <span class="validation-field-value">{{
            fieldGroup.controls['field'].value
          }}</span>
          <span
            class="validation-field-value"
            [class.has-error]="!fieldGroup.controls['prompt'].valid"
            >
            <div class="tooltip-container">
              <input [formControl]="fieldGroup.controls['prompt']" name="prompt-{{ i }}" type="text"/>
              <div class="icon-container">
                @if (fieldGroup.controls['field'].value === 'postal_code') {
                  <i class="fa fa-question-circle icon-color" aria-hidden="true" (mouseover)="showTooltip = true" (mouseout)="showTooltip = false"></i>
                }
              </div>
              @if (showTooltip && fieldGroup.controls['field'].value === 'postal_code') {
                <div class="tooltip">
                  <p>Verification by postal code will only verify the first 5 digits if the customer has a 9 digit postal zip on file.</p>
                </div>
              }
            </div>
          </span>
        </div>
      }
      <ng-container [formGroup]="verificationConfigForm">
        <rn-text-input
          [inputLabel]="'Header'"
          [inputControl]="verificationConfigForm.controls['header']"
          [placeholderText]="'Account Confirmation'"
          [isWide]="true"
          >
          <rn-input-info-box
            input-info-box
            [svgHeight]="40"
            [svgPosition]="'8,0 8,24, 2,30 8,36 8,80'"
        [text]="
          'Header for account verification. Will default to:<br>Account Confirmation'
        "
          ></rn-input-info-box>
        </rn-text-input>
        <div class="input-container">
          <div class="input">
            <div class="label-tip">
              <label>Verification Message</label>
            </div>
            <app-tiny-editor
              class="tiny-editor-mentions"
              [elementId]="'tiny-editor-express-consent'"
              [formControl]="verificationConfigForm.controls['body']"
              >
            </app-tiny-editor>
            <p class="tip-text">
              <svg width="15" height="80" style="float: left">
                <polyline
                  points="8,0 8,24, 2,30 8,36 8,80"
                  style="fill: none; stroke: #5b5a59; stroke-width: 1"
                  />
              </svg>
              <span
                >Text to show user. Will default to:<br />Please enter the
                information below to confirm your account and access your
                messages.</span
                >
              </p>
            </div>
          </div>
          <rn-text-input
            [inputLabel]="'Button Label'"
            [inputControl]="verificationConfigForm.controls['button_label']"
            [placeholderText]="'Submit'"
            [isWide]="true"
            >
            <rn-input-info-box
              input-info-box
              [svgHeight]="40"
              [svgPosition]="'8,0 8,24, 2,30 8,36 8,80'"
              [text]="'Button for account verification. Will default to:<br>Submit'"
            ></rn-input-info-box>
          </rn-text-input>
        </ng-container>
      }
    </div>
  }
